import {useOutletContext} from "react-router-dom";

import {permit_extension_view_adapter} from "permitextension/model";
import {PermitExtensionService} from "permitextension/service";
import {useNavigateWithReload} from "base/navigation/hooks";
import {useErrors} from "base/error/provider";

import {PermitExtensionTypesAndDatesTabs} from ".";
import {FormContainer} from "base/form/components";

const PermitExtensionTypesAndDatesStep = () => {
    const {extension: entity, isStepEditable} = useOutletContext();
    const navigate = useNavigateWithReload();
    const {handleErrors} = useErrors();

    const handleExtensionFormSubmit = updatedEntity => {
        PermitExtensionService.update(permit_extension_view_adapter(updatedEntity))
            .then(data => {
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    return (
        <FormContainer>
            <PermitExtensionTypesAndDatesTabs
                entity={entity}
                onSubmit={handleExtensionFormSubmit}
                isStepEditable={isStepEditable}
            />
        </FormContainer>
    );
};

export default PermitExtensionTypesAndDatesStep;
